<template>
  <div>

    <a-tabs type="card" defaultActiveKey="1">
      <a-tab-pane tab="Payout" key="1">
        <payout2></payout2>
      </a-tab-pane>
      <a-tab-pane tab="Income" key="2">
        <income2></income2>
      </a-tab-pane>
    </a-tabs>

  </div>
</template>

<script>
import moment from "moment";
import userinfo from "../utils/userinfo.js";

import payout2 from './payout2.vue'
import income2 from './income2.vue'



export default {
  components: {
    payout2,
    income2
  },
  data() {
    return {
    }
  },
  mounted() {
  }
};
</script>
<style>
</style>